/** Redirects de URLs legadas para o prefixo unificado /solicitacoes/* */
const legacyRedirects = [
    // Translado
    {
        path: 'translado/solicitacoes',
        redirect: { name: 'Translado_Solicitacoes' },
    },
    {
        path: 'translado/solicitacoes/nova',
        redirect: { name: 'Translado_Solicitacoes_Nova' },
    },
    {
        path: 'translado/solicitacoes/editar/:id',
        redirect: (to) => ({ name: 'Translado_Solicitacoes_Editar', params: { id: to.params.id } }),
    },
    {
        path: 'translado/solicitacoes/:id',
        redirect: (to) => ({ name: 'Translado_Solicitacoes_Detalhar', params: { id: to.params.id } }),
    },
    // Hospedagem
    {
        path: 'solicitacoes-servicos/hospedagem',
        redirect: { name: 'SolicitacoesServicos_Hospedagem' },
    },
    {
        path: 'solicitacoes-servicos/hospedagem/nova',
        redirect: { name: 'SolicitacoesServicos_Hospedagem_Nova' },
    },
    {
        path: 'solicitacoes-servicos/hospedagem/editar/:id',
        redirect: (to) => ({ name: 'SolicitacoesServicos_Hospedagem_Editar', params: { id: to.params.id } }),
    },
    {
        path: 'solicitacoes-servicos/hospedagem/:id',
        redirect: (to) => ({ name: 'SolicitacoesServicos_Hospedagem_Detalhar', params: { id: to.params.id } }),
    },
    // Tramitações Jurídicas
    {
        path: 'solicitacoes-servicos/tramitacoes-juridicas',
        redirect: { name: 'SolicitacoesServicos_TramitacoesJuridicas_Listagem' },
    },
    {
        path: 'solicitacoes-servicos/tramitacoes-juridicas/inserir',
        redirect: { name: 'SolicitacoesServicos_TramitacoesJuridicas_Inserir' },
    },
    {
        path: 'solicitacoes-servicos/tramitacoes-juridicas/:id',
        redirect: (to) => ({ name: 'SolicitacoesServicos_TramitacoesJuridicas_Detalhar', params: { id: to.params.id } }),
    },
    // Mão de Obra Temporária
    {
        path: 'solicitacoes-servicos/mao-de-obra-temporaria',
        redirect: { name: 'SolicitacoesServicos_MOT_Listagem' },
    },
    {
        path: 'solicitacoes-servicos/mao-de-obra-temporaria/nova',
        redirect: { name: 'SolicitacoesServicos_MOT_Nova' },
    },
    {
        path: 'solicitacoes-servicos/mao-de-obra-temporaria/:id/editar',
        redirect: (to) => ({ name: 'SolicitacoesServicos_MOT_Editar', params: { id: to.params.id } }),
    },
    {
        path: 'solicitacoes-servicos/mao-de-obra-temporaria/:id',
        redirect: (to) => ({ name: 'SolicitacoesServicos_MOT_Detalhar', params: { id: to.params.id } }),
    },
    {
        path: 'solicitacoes-servicos',
        redirect: { name: 'SolicitacoesServicos_Hospedagem' },
    },
    {
        path: 'translado',
        redirect: { name: 'Translado_Solicitacoes' },
    },
];

export default legacyRedirects;
